var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterFunnel = function SvgFilterFunnel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.167 2.683c0-.326 0-.49.063-.614a.6.6 0 0 1 .255-.255c.125-.064.288-.064.615-.064h9.8c.327 0 .49 0 .615.064.11.056.199.145.255.255.063.124.063.288.063.614v.39c0 .158 0 .236-.019.309a.6.6 0 0 1-.082.18c-.043.063-.102.114-.22.217L8.78 7.013c-.118.102-.177.154-.22.216a.6.6 0 0 0-.082.18c-.02.074-.02.152-.02.309v3.05c0 .114 0 .17-.018.22a.3.3 0 0 1-.077.114.7.7 0 0 1-.198.099l-1.983.793c-.215.086-.322.129-.408.11a.3.3 0 0 1-.184-.124c-.048-.073-.048-.188-.048-.42V7.719c0-.157 0-.235-.02-.308a.6.6 0 0 0-.082-.181c-.043-.062-.102-.114-.22-.216L1.489 3.779a1.3 1.3 0 0 1-.22-.216.6.6 0 0 1-.083-.181c-.02-.073-.02-.151-.02-.308z"
  })));
};
export default SvgFilterFunnel;